// extracted by mini-css-extract-plugin
export default {"PostalCodeDropDown":"AvP4aL1aj_QsdOrOQzED"};